// extracted by mini-css-extract-plugin
module.exports = {"JobBoardContainer":"JobBoardContainer_JobBoardContainer__2k0s8","FiltersLegendWrapper":"JobBoardContainer_FiltersLegendWrapper__l7Kpb"};